import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Main from './Main'
import PartnerSettings from './partnersettings/PartnerSettings'
import ForeignCurrency from './foreign-currency/ForeignCurrency'
import KassaSettings from './kassasettings/KassaSettings'
import CustomerSettings from './customersettings/CustomerSettings'
import { CONFIG } from '../../../config'

const Settings = () => {
  return (
    <Routes>
        <Route path="" element={<Main />}/>
        <Route path="partnerinstellingen/*" element={<PartnerSettings />}/>
        <Route path="kassainstellingen/*" element={<KassaSettings />}/>
        <Route path="eindklantinstellingen/*" element={<CustomerSettings />}/>
        {CONFIG.order_and_collect.order.enable_foreign_currency &&
        <Route path="vreemde-valuta/*" element={<ForeignCurrency />}/>
        }
    </Routes>
  )
}

export default Settings